import React, { useCallback, useContext, useMemo, useState } from "react";
import { StyleSheet, View } from "react-native";
import { getBestiaryVisibleEnemies } from "../backend/exploration/enemies/Enemy";
import { PlayerContext } from "../backend/PlayerContext";
import { BestiaryEnemyContainer } from "./utility/BestiaryEnemyContainer";
import Divider from "./utility/Divider";
import { Text } from "./utility/Text";

function BestiaryContainer() {
  const [expandedEnemyId, setExpandedEnemyId] = useState("");
  const setEnemyCallback = useCallback(
    (enemyId: string) => {
      if (expandedEnemyId == enemyId) {
        setExpandedEnemyId("");
      } else {
        setExpandedEnemyId(enemyId);
      }
    },
    [expandedEnemyId],
  );

  const playerContext = useContext(PlayerContext);
  const allEnemies = getBestiaryVisibleEnemies(playerContext);

  const enemyString = allEnemies.map((enemy) => enemy.getId()).join(",");

  const enemyContainers = useMemo(
    () =>
      allEnemies.map((enemy) => {
        return (
          <BestiaryEnemyContainer
            key={enemy.getId()}
            enemy={enemy}
            collapsed={expandedEnemyId != enemy.getId()}
            onPressExpand={setEnemyCallback.bind(null, enemy.getId())}
          />
        );
      }),
    [enemyString, expandedEnemyId, setExpandedEnemyId],
  );

  return useMemo(() => {
    if (allEnemies.length === 0) {
      return null;
    }
    return (
      <View>
        {enemyContainers.map((enemyContainer, idx) => {
          return (
            <View key={allEnemies[idx].getId()}>
              <Divider />
              {enemyContainer}
            </View>
          );
        })}
        <Divider />
      </View>
    );
  }, [enemyString, enemyContainers]);
}

export default function Bestiary() {
  return (
    <View>
      <View style={styles.headerContainer}>
        <Text h1>Bestiary</Text>
      </View>

      <View style={styles.bestiaryContainer}>
        <BestiaryContainer />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "stretch",
    justifyContent: "flex-start",
    width: "100%",
  },
  headerContainer: {
    marginBottom: 16,
  },
  valueText: {
    minWidth: 60,
    textAlign: "right",
    marginLeft: 8,
  },
  valueTextLong: {
    minWidth: 112,
  },
  bestiaryContainer: {
    marginTop: 16,
  },
  captionText: {
    flex: 1,
  },
});
